const searchElements = {
    icon: document.getElementById("search-icon"),
    bar: document.getElementById("search-bar"),
    close: document.getElementById("close-search"),
    input: document.getElementById("search-input"),
    resultsList: document.getElementById("search-results-list"),
    searchIcon: document.getElementById("search-action"),
    formSearch: document.getElementById('form-search'),
};

const mobileSearchElements = {
    container: document.getElementById("search-mobile-container"),
    input: document.getElementById("search-input-mobile"),
    resultsList: document.getElementById("search-results-list-mobile"),
    searchIcon: document.getElementById("search-action-mobile"),
    close: document.getElementById("close-search-mobile"),
    closeInput: document.getElementById("close-search-mobile-input"),
    formSearch: document.getElementById('form-search-mobile'),
};

let debounceTimer;
let mobileDebounceTimer;

const debounce = (callback, delay = 300) => {
    return (...args) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => callback(...args), delay);
    };
};

const debounceMobile = (callback, delay = 300) => {
    return (...args) => {
        clearTimeout(mobileDebounceTimer);
        mobileDebounceTimer = setTimeout(() => callback(...args), delay);
    };
};

const fetchSearchResults = async (query) => {
    const url = `${window.Shopify.routes.root}search/suggest?q=${query}&resources[type]=product&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title&section_id=organism-search-suggestion-results`;
    return fetch(url);
};

const parseSearchResults = async (response) => {
    const text = await response.text();
    const resultsMarkup = new DOMParser().parseFromString(text, 'text/html');
    return resultsMarkup.querySelector('#predictive-search');
};

const updateSearchResults = (resultsMarkup) => {
    searchElements.resultsList.innerHTML = "";
    searchElements.resultsList.appendChild(resultsMarkup);
};

const updateMobileSearchResults = (resultsMarkup) => {
    mobileSearchElements.resultsList.innerHTML = "";
    mobileSearchElements.resultsList.appendChild(resultsMarkup);
};

const closeSearchResults = () => {
    searchElements.resultsList.classList.replace("opacity-100", "opacity-0");
    setTimeout(() => {
        searchElements.resultsList.classList.add("hidden");
        searchElements.resultsList.innerHTML = "";
    }, 150);
};

const closeMobileSearchResults = () => {
    mobileSearchElements.resultsList.classList.replace("opacity-100", "opacity-0");
    setTimeout(() => {
        mobileSearchElements.resultsList.classList.add("hidden");
        mobileSearchElements.resultsList.innerHTML = "";
    }, 150);
};

const handleSearchInput = debounce(async (event) => {
    const query = event.target.value.trim();
    if (!query) {
        closeSearchResults();
        return;
    }

    searchElements.input.value = query;
    try {
        const response = await fetchSearchResults(query);
        if (!response.ok) throw new Error(`${response.status}: ${await response.text()}`);
        const resultsMarkup = await parseSearchResults(response);
        updateSearchResults(resultsMarkup);
        searchElements.resultsList.classList.remove('hidden');
        requestAnimationFrame(() => {
            searchElements.resultsList.classList.replace('opacity-0', 'opacity-100');
        });
        StoreUtils.handleScaRef('.search-result-card', false);
    } catch (error) {
        console.error('Erro na busca:', error);
    }
}, 300);

const handleMobileSearchInput = debounceMobile(async (event) => {
    const query = event.target.value.trim();
    if (!query) {
        closeMobileSearchResults();
        return;
    }

    mobileSearchElements.input.value = query;
    try {
        const response = await fetchSearchResults(query);
        if (!response.ok) throw new Error(`${response.status}: ${await response.text()}`);
        const resultsMarkup = await parseSearchResults(response);
        updateMobileSearchResults(resultsMarkup);
        mobileSearchElements.resultsList.classList.remove('hidden');
        requestAnimationFrame(() => {
            mobileSearchElements.resultsList.classList.replace('opacity-0', 'opacity-100');
        });
        StoreUtils.handleScaRef('.search-result-card', false);
    } catch (error) {
        console.error('Erro na busca:', error);
    }
}, 300);

const toggleMobileSearch = () => {
    const container = mobileSearchElements.container;
    const isOpen = container.style.maxHeight !== '0px' && container.style.maxHeight !== '';
    
    if (isOpen) {
        container.style.maxHeight = '0px';
        closeMobileSearchResults();
        mobileSearchElements.input.value = "";
        mobileSearchElements.input.blur();
    } else {
        const containerTop = container.getBoundingClientRect().top;
        const availableHeight = Math.max(window.innerHeight - containerTop, 300);
        container.style.maxHeight = `${availableHeight}px`;
        setTimeout(() => {
            mobileSearchElements.input.focus();
        }, 100);
    }
};

const toggleSearch = () => {
    const isMobile = window.innerWidth < 1024;
    
    if (isMobile) {
        toggleMobileSearch();
    } else {
        searchElements.input.focus();
    }
};

const validateAndSubmitSearch = (event) => {
    const query = searchElements.input.value.trim();
    if (!query) {
        event.preventDefault();
        searchElements.input.focus();
    } else {
        const form = searchElements.input.closest("form");
        if (form) {
            form.submit();
        }
    }
};

const validateAndSubmitMobileSearch = (event) => {
    const query = mobileSearchElements.input.value.trim();
    if (!query) {
        event.preventDefault();
        mobileSearchElements.input.focus();
    } else {
        const form = mobileSearchElements.input.closest("form");
        if (form) {
            form.submit();
        }
    }
};

if (searchElements.input) {
    searchElements.input.addEventListener("input", handleSearchInput);
}
if (searchElements.icon) {
    searchElements.icon.addEventListener("click", toggleSearch);
}
if (searchElements.close) {
    searchElements.close.addEventListener("click", toggleSearch);
}
if (searchElements.searchIcon) {
    searchElements.searchIcon.addEventListener('click', validateAndSubmitSearch);
}
if (searchElements.input) {
    searchElements.input.addEventListener("keypress", function (event) {
        if (event.key === "Enter") {
            validateAndSubmitSearch(event);
        }
    });
}

if (mobileSearchElements.input) {
    mobileSearchElements.input.addEventListener("input", handleMobileSearchInput);
}
if (mobileSearchElements.close) {
    mobileSearchElements.close.addEventListener("click", toggleMobileSearch);
}
if (mobileSearchElements.closeInput) {
    mobileSearchElements.closeInput.addEventListener("click", toggleMobileSearch);
}
if (mobileSearchElements.searchIcon) {
    mobileSearchElements.searchIcon.addEventListener('click', validateAndSubmitMobileSearch);
}
if (mobileSearchElements.input) {
    mobileSearchElements.input.addEventListener("keypress", function (event) {
        if (event.key === "Enter") {
            validateAndSubmitMobileSearch(event);
        }
    });
}

window.addEventListener("resize", () => {
    if (!mobileSearchElements.container) return;
    const isOpen = mobileSearchElements.container.style.maxHeight !== '0px' && mobileSearchElements.container.style.maxHeight !== '';
    if (!isOpen) return;
    const containerTop = mobileSearchElements.container.getBoundingClientRect().top;
    const availableHeight = Math.max(window.innerHeight - containerTop, 300);
    mobileSearchElements.container.style.maxHeight = `${availableHeight}px`;
});

document.addEventListener("click", function (event) {
    if (searchElements.resultsList && searchElements.input) {
        const isClickInsideResults = searchElements.resultsList.contains(event.target);
        const isClickInsideInput = searchElements.input.contains(event.target);
        
        if (!isClickInsideResults && !isClickInsideInput) {
            closeSearchResults();
            searchElements.input.value = "";
        }
    }
    
    if (mobileSearchElements.container && mobileSearchElements.input) {
        const isClickInsideContainer = mobileSearchElements.container.contains(event.target);
        const isClickOnSearchIcon = searchElements.icon && searchElements.icon.contains(event.target);
        
        if (!isClickInsideContainer && !isClickOnSearchIcon) {
            const isOpen = mobileSearchElements.container.style.maxHeight !== '0px' && mobileSearchElements.container.style.maxHeight !== '';
            if (isOpen) {
                toggleMobileSearch();
            }
        }
    }
});
